import React, { useEffect, useState } from "react";
import avatar from "../assets/imgs/new/avatar.png";
import {
  Button,
  Card,
  Col,
  CustomInput,
  Row,
  Label,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "reactstrap";
import Media from "../assets/imgs/new/Media.png";
import CreateMemora from "../components/Modals/CreateMemora";
import { useSelector, useDispatch } from "react-redux";
import { getMemoirs } from "../redux/actions/memoir.action";
import MemoirCard from "../components/MemoirCard";
import MainHeader from "../components/MainHeader";
import ArrowLeft from "../assets/imgs/new/arrow-left.png";
import ArrowRight from "../assets/imgs/new/arrow-right.png";
import {
  updateFirstSignIn,
  updateProfileImage,
} from "../redux/actions/auth.action";
import Avatar from "react-avatar";
import CustomCard from "../components/CustomCard";
import vector11 from "../assets/imgs/dashboard/camera.png";
import Ellipse13 from "../assets/imgs/Ellipse 13.png";
import logo1 from "../assets/imgs/LOGO 1.png";
import image4 from "../assets/imgs/04.png";
import plus from "../assets/imgs/plus.png";
import MemoraLogo from "../assets/imgs/memora_logo_small.png";
import moment from "moment";
import { Link } from "react-router-dom";
function Memoirs() {
  const [modals, setModals] = useState({
    category: false,
    createTimeline: false,
    addMedia: false,
  });
  // const [dropOpen, setDropOpen] = useState(-1)
  const [profileType, setProfileType] = useState("person");
  const [selectedCat, setSelectedCat] = useState("");
  const [filterCat, setFilterCat] = useState("All");
  const [searchFilter, setSearchFilter] = useState("");
  console.log("searchFilter", searchFilter);
  const [selectedDate, setSelectedDate] = useState("");
  const [memoirData, setMemoirData] = useState({
    memoir_title: "",
    title: "",
    first_name: "",
    last_name: "",
    introduction: "",
    relationship: "",
    date_of_birth: "",
    date_of_death: "",
    home_town: "",
    isMemoirPublic: false,
    isHomeTownPublic: false,
    isDOBPublic: false,
    isHideFromSearchEngines: false,
    isIntroductionVisible: false,
  });

  // filter On the basis of category

  const [categories, setCategories] = useState([
    { name: "All" },
    { name: "Myself" },
    { name: "Someone else" },
    { name: "Pet" },
    { name: "Birthday" },
    { name: "Anniversary" },
    { name: "Event" },
    { name: "Coorperate" },
    { name: "Object" },
    { name: "Other" },
  ]);

  let newDateSet = moment(selectedDate).format("DD/MM/YYYY");
  const clearHndler = () => {
    setFilterCat("All");
    setSelectedDate("");
  };
  console.log("category for date", selectedDate);
  const [modal, setModal] = useState(false);
  const [profileImg, setProfileImg] = useState(null);
  const { memoirs } = useSelector((state) => state.memoir);
  console.log("memoirs", memoirs);
  const [sortedArray, setSortedArray] = useState([]);
  console.log(sortedArray,'sortedArray')
  const { uid, user } = useSelector((state) => state.auth);
  const { firstSignIn } = useSelector((state) => state.authUser);
  const authUser = useSelector((state) => state.authUser);
  const { imageLoading } = useSelector((state) => state.auth);
  const acceptedImageTypes = ["png", "jpg", "PNG", "JPG", "jpeg", "JPEG"];

  const dispatch = useDispatch();
  const scrollMemoirsCard = (shift) => {
    let el = document.getElementById("memoir_cards");
    el.scrollLeft += shift;
  };
  const toggle = () => {
    setModal(!modal);
  };

  const toggleModal = (name) => {
    let newModal = JSON.parse(JSON.stringify(modals));
    for (let modal of Object.keys(newModal)) {
      if (modal != name) newModal[modal] = false;
    }
    newModal[name] = !newModal[name];
    setModals(newModal);
  };

  useEffect(() => {
    if (memoirs.length == 0 && uid) {
      dispatch(getMemoirs(uid));
    }
  }, [uid]);

  useEffect(() => {
    if (firstSignIn && uid) {
      // toggleModal('category');
      toggle();
      dispatch(updateFirstSignIn(uid));
    }
  }, [firstSignIn]);
  // console.log('authUser', authUser.hasOwnProperty('profile_image'));
  // console.log('memora', logo1);
  useEffect(() => {
    // const sortedMemoir = memoirs.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
    // console.log(sortedMemoir,'<>')
  }, [memoirs]);
  return (
    <>
      {/* <Button color='danger' onClick={toggle} className='mb-5'>
				View personal data
			</Button> */}
      <Modal isOpen={modal} toggle={toggle} size="xl">
        <ModalHeader toggle={toggle}></ModalHeader>
        <ModalBody className="text-center">
          <h2 className="text-center">
            Welcome {authUser.firstname} {authUser.lastname}
          </h2>
          <p>Thanks for signing up. Here are some items to get you started.</p>
          <div className="">
            {imageLoading ? (
              <Spinner />
            ) : (
              <Avatar
                round={true}
                className=""
                src={
                  authUser.hasOwnProperty("profile_image")
                    ? authUser.profile_image
                    : logo1
                }
                size={168}
              />
            )}

            {!imageLoading && (
              <>
                <img
                  src={Ellipse13}
                  alt=""
                  className="position-relative"
                  style={{ top: "70px", right: "50px" }}
                />
                <label for="update-profile">
                  <img
                    src={vector11}
                    alt="vector"
                    for="update-profile"
                    className="position-relative"
                    style={{
                      top: "70px",
                      right: "79px",
                      cursor: "pointer",
                    }}
                  />
                </label>
              </>
            )}
          </div>

          <Input
            type="file"
            hidden
            id="update-profile"
            onChange={(e) => {
              setProfileImg(e.target.files[0]);
              let profile = null;
              if (authUser.hasOwnProperty("profile_image")) {
                profile = authUser.profile_image.includes("firebasestorage")
                  ? authUser.profile_image
                  : null;
              }

              dispatch(
                updateProfileImage(authUser.id, e.target.files[0], profile)
              );
            }}
          ></Input>

          <h2
            className="mt-5"
            style={{ cursor: "pointer" }}
            onClick={() => this.toggleModal("category")}
          >
            What would you like to do?
          </h2>
          <Row className="mt-4 justify-conten-center">
            <Col className="d-flex justify-content-center mt-3">
              <CustomCard
                image={logo1}
                title={"Create a Memoir"}
                para={"On your own visual Timeline"}
                onClick={() => {
                  toggleModal("category");
                  toggle();
                }}
              />
            </Col>
            <Col className="d-flex justify-content-center mt-3">
              <CustomCard
                image={plus}
                title={"Start a new life story"}
                para={"For a loved one, memorial something else"}
                onClick={() => {
                  toggleModal("category");
                  setSelectedCat("Myself");
                  toggle();
                }}
              />
            </Col>
            <Col className="d-flex justify-content-center text-black mt-3">
              <Link to="/dashboard/future-messages">
                <CustomCard
                  image={image4}
                  title={"Send a future message"}
                  para={"Months, years and decades from now"}
                />
              </Link>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      {/* Category Modal */}
      <CreateMemora
        isOpen={modals}
        toggleModal={toggleModal}
        memoirData={memoirData}
        setMemoirData={setMemoirData}
        profileType={profileType}
        setProfileType={setProfileType}
        selectedCat={selectedCat}
        setSelectedCat={setSelectedCat}
      />
      <div className="container-fluid pt-3">
        <MainHeader heading={"View your memoirs"} />
        <hr className="mb-0" />

        <div className="filterby mt-4">
          <h4 className="font-weight-bold">Filter By</h4>
          <Row className="mt-5">
            <Col md="3">
              <Label>Selected Date</Label>
              <Input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              ></Input>
            </Col>
            <Col md="4">
              <Label>Filter </Label>
              <select
                className="form-control"
                onChange={(e) => setFilterCat(e.target.value)}
              >
                {categories.map((cat) => {
                  return (
                    <option value={cat.name} selected={filterCat == cat.name}>
                      {cat.name}
                    </option>
                  );
                })}
              </select>
            </Col>
            <Col md="5" className="align-items-center">
              <button
                className="btn btn-primary clear-btn"
                onClick={clearHndler}
              >
                clear
              </button>
            </Col>
          </Row>
          {/* <Row className='mt-4'>
						<Col md='4'>
							<Label>Filter by</Label>
							<Input type='select'></Input>
						</Col>
					</Row> */}
        </div>
        <div className="mt-5">
          <div className="d-flex">
            <div>
              <h5 className="font-weight-bold">Memoirs</h5>
              <p className="m-0">View your created memoirs</p>
            </div>
            <Button
              className="ml-auto btn-outline dashboard-btn"
              onClick={() => toggleModal("category")}
            >
              + Create new
            </Button>
          </div>
          <Row className="mt-4">
            <Col className="position-relative memoirs">
              <input
                type="text"
                placeholder="Search"
                className="memoirs__filter-input"
                value={searchFilter}
                onChange={(e) => {
                  setSearchFilter(e.target.value);
                }}
              />
              <button
                className="position-absolute memoirs__filter-input-box"
                size="lg"
              >
                <i className="fas fa-search fa-1x memoirs__filter-input-box-icon"></i>
              </button>
            </Col>
          </Row>
          <Row
            id="memoir_cards"
            className="mt-5  mb-2 flex-nowrap"
            style={{ overflow: "auto", scrollBehavior: "smooth" }}
          >
            {memoirs && memoirs.length > 0 ? (
              memoirs
                .filter((data) => {
                  // console.log("dataaa", data);
                  if (
                    selectedDate === "" &&
                    filterCat === "All" &&
                    searchFilter == ""
                  ) {
                    return data;
                  } else if (
                    data.memoir_title
                      ?.toLowerCase()
                      ?.includes(searchFilter?.toLowerCase()) &&
                    filterCat === "All" &&
                    selectedDate === ""
                  ) {
                    return data;
                  } else if (
                    searchFilter === "" &&
                    filterCat === data.category &&
                    selectedDate === ""
                  ) {
                    return data;
                  } else if (
                    searchFilter === "" &&
                    filterCat === "All" &&
                    moment
                      .unix(data.created_at.seconds)
                      .format("DD/MM/YYYY") === newDateSet
                  ) {
                    return data;
                  } else if (
                    searchFilter === "" &&
                    filterCat === data.category &&
                    moment
                      .unix(data.created_at.seconds)
                      .format("DD/MM/YYYY") === newDateSet
                  ) {
                    return data;
                  } else if (
                    data.memoir_title
                      ?.toLowerCase()
                      ?.includes(searchFilter?.toLowerCase()) &&
                    filterCat === "All" &&
                    moment
                      .unix(data.created_at.seconds)
                      .format("DD/MM/YYYY") === newDateSet
                  ) {
                    return data;
                  } else if (
                    data.memoir_title
                      ?.toLowerCase()
                      ?.includes(searchFilter?.toLowerCase()) &&
                    filterCat === data.category &&
                    selectedDate == ""
                  ) {
                    return data;
                  } else if (
                    data.memoir_title
                      ?.toLowerCase()
                      ?.includes(searchFilter?.toLowerCase()) &&
                    filterCat === data.category &&
                    moment
                      .unix(data.created_at.seconds)
                      .format("DD/MM/YYYY") === newDateSet
                  ) {
                    return data;
                  }
                })
                .map((mem, index) => (
                  <Col lg="4" md="6" xs="12" className="mb-4">
                    <MemoirCard
                      index={index}
                      mem={mem}
                      height="130px"
                      showMenu={true}
                      linkable={true}
                      settings={true}
                    />
                  </Col>
                ))
            ) : (
              <Col>
                <h4>No Memoirs Found</h4>
              </Col>
            )}
          </Row>
          {memoirs && memoirs.length > 3 && (
            <div className="text-right">
              <img
                src={ArrowLeft}
                alt="left"
                className="pointer"
                onClick={() => scrollMemoirsCard(-340)}
              />
              <span className="ml-3 mr-1">{1}</span>-
              <span className="ml-1 mr-3">{memoirs.length}</span>
              <img
                src={ArrowRight}
                alt="right"
                className="pointer"
                onClick={() => scrollMemoirsCard(340)}
              />
            </div>
          )}
        </div>
        <div className="mt-5">
          <Link to="/dashboard/collaboratives">
            <Button className="btn-outline dashboard-btn">
              View Memoir shared with me
            </Button>
          </Link>
          <Link to="/dashboard/collaboratives">
            <Button className="btn-outline ml-4 dashboard-btn">
              Manage Contributor
            </Button>
          </Link>
        </div>
        {/* <div className="mt-5">
          <div className="d-flex">
            <div>
              <h5 className="font-weight-bold">Wedding</h5>
              <p className="m-0">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industr.
              </p>
            </div>
            <Button className="ml-auto btn-outline">+ Create new</Button>
          </div>
          <Row className="mt-5 flex-nowrap" style={{ overflow: 'auto' }}>
            {new Array(6).fill(1).map((_) => (
              <Col md="3" className="mb-4">
                <Card>
                  <div
                    className="position-relative"
                    style={{
                      background: `url(${collaborator_bg})`,
                      height: 130,
                    }}
                  >
                    <div
                      className="position-absolute"
                      style={{
                        top: '100%',
                        left: '50%',
                        transform: 'translate(-50%,-50%)',
                      }}
                    >
                      <img src={collaborator} />
                    </div>
                  </div>
                  <div className="text-center">
                    <h5 className="font-weight-bold mt-5 pt-4">Tom Tomphson</h5>
                    <p className="f-14">Birthday Celebration event</p>
                    <p className="mt-4">He was a great Event Manager</p>
                  </div>
                  <div className="card-f f-14 py-1 mt-4 text-center position-relative">
                    10/2/2021
                    <i
                      className="fa fa-ellipsis-v position-absolute"
                      style={{
                        top: '50%',
                        right: '10px',
                        transform: 'translateY(-50%)',
                      }}
                    ></i>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div> */}
        {/* <div className="mt-3">
          <Button className="btn-outline">View Memoir shared with me</Button>
          <Button className="btn-outline ml-3">Manage Contributor</Button>
        </div>
        <div className="mt-5">
          <h5 className="font-weight-bold">Add new section</h5>
          <div className="darg-drop mt-4" style={{ height: '200px' }}>
            <div className="text-center">
              <i className="text-muted fa fa-plus"></i>
              <p>
                <span className="text-muted">Add Photo/Videos </span>
                or drop file here
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

const LC_Media = (props) => {
  let { active, setActiveMedia } = props;
  return (
    <div
      className={`lc_media pointer p-4 ${active ? "active" : ""}`}
      onClick={setActiveMedia}
    >
      <div className="w-100 position-relative">
        <img src={Media} className="media_img" />
        <div
          className={`position-absolute ${active ? "d-block" : "d-none"}`}
          style={{ top: 10, left: 10 }}
        >
          <CustomInput
            type="checkbox"
            id="exampleCustomCheckbox"
            checked={true}
            label=""
          />
        </div>
      </div>
    </div>
  );
};

const QRCodeTemplate = (props) => {
  let { qrCode, idx, active, setActiveQRCode, bgColor } = props;
  return (
    <div onClick={setActiveQRCode}>
      <div
        className="pointer qr-code-wrapper p-4"
        style={{ backgroundColor: bgColor, borderRadius: 8 }}
      >
        <img
          src={qrCode}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </div>
      <div className="mt-3">
        <CustomInput
          type="radio"
          id={`Template ${idx}`}
          name="customRadio"
          checked={active}
          label={`Template ${idx}`}
        />
      </div>
    </div>
  );
};

export default Memoirs;
